import { render, staticRenderFns } from "./concierge-sellers-form.vue?vue&type=template&id=555fd070&"
import script from "./concierge-sellers-form.vue?vue&type=script&lang=js&"
export * from "./concierge-sellers-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports